import { Swiper, SwiperSlide } from 'swiper/react'
import { Lazy, Navigation } from 'swiper'
import { InView } from 'react-intersection-observer'

import type { CarroselDataCMS } from '.'
import InfoBannerItem from './InfoBannerItem'

type InfoBannerCarroselProps = {
  carrosel: CarroselDataCMS[]
  sendPromoFeatureViewedEvent: (item: CarroselDataCMS, index: number) => void
  title: string
  section?: string
  locationOnPage?: string
}

const InfoBannerCarrosel = ({
  carrosel,
  sendPromoFeatureViewedEvent,
  locationOnPage,
  section,
  title,
}: InfoBannerCarroselProps) => {
  return (
    <Swiper
      className="slick-slide-swiper"
      navigation={{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }}
      breakpoints={{
        1024: {
          slidesPerView: 5,
        },
        768: {
          slidesPerView: 3,
        },
        320: {
          slidesPerView: 3,
        },
      }}
      lazy={{
        loadPrevNext: true,
      }}
      modules={[Navigation, Lazy]}
    >
      <div className="swiper-button-prev !flex" />
      <div className="swiper-button-next !flex" />
      {carrosel.map((item: CarroselDataCMS, index: number) => {
        return item?.carroselContent?.enable ? (
          <SwiperSlide key={index}>
            <InView
              as="div"
              threshold={0.7}
              onChange={(inView) => {
                if (inView) {
                  sendPromoFeatureViewedEvent(item, index)
                }
              }}
              triggerOnce
            >
              <InfoBannerItem
                key={index}
                infobanner={item}
                index={index}
                title={title}
                section={section}
                locationOnPage={locationOnPage}
              />
            </InView>
          </SwiperSlide>
        ) : null
      })}
    </Swiper>
  )
}

export default InfoBannerCarrosel
